import type { Node, Edge } from 'reactflow'
import type { ReactFlowTraceExport } from '../../../lib/api'
import { STATUS_COLORS, AGENT_ROLE_COLORS } from '../../../lib/agentColors'
import type { AgentNodeData } from './nodes/AgentNode'

export function buildTraceGraph(trace: ReactFlowTraceExport): { nodes: Node[]; edges: Edge[] } {
  const nodes: Node<AgentNodeData>[] = trace.nodes.map((n) => {
    const status = (n.data.status as AgentNodeData['status']) ?? 'pending'
    const statusStyle = STATUS_COLORS[status]
    const roleColor = AGENT_ROLE_COLORS[n.data.agent_role as string ?? ''] ?? '#6B7280'

    return {
      id: n.id,
      type: 'agentNode',
      position: n.position,
      data: {
        label: n.data.label as string,
        agentId: null,
        team: '',
        agentRole: (n.data.agent_role as string) ?? '',
        description: (n.data.description as string) ?? (n.data.phase as string) ?? '',
        status,
        tokens_used: n.data.tokens_used as number | undefined,
        duration_ms: n.data.duration_ms as number | undefined,
        output_preview: (n.data.output_preview as string | null) ?? null,
      },
      style: {
        borderColor: status !== 'pending' ? statusStyle.border : roleColor,
        backgroundColor: status !== 'pending' ? statusStyle.bg : '#FFFFFF',
      },
    }
  })

  const edges: Edge[] = trace.edges.map((e) => ({
    id: e.id,
    source: e.source,
    target: e.target,
    type: e.type ?? 'smoothstep',
    animated: e.animated ?? false,
    label: e.label,
    style: e.style as React.CSSProperties | undefined,
    data: {
      tokens: (e.data?.tokens as number) ?? 0,
    },
  }))

  return { nodes, edges }
}
